import { useEffect, useState, useMemo } from "react";
import { debounce } from "../utils";

const breakPointValue = (obj, dimension) => {
  if (!obj) return null;
  return Object.keys(obj).reduce((acc, cur) => {
    if (acc <= obj[cur] && dimension > cur) {
      acc = obj[cur];
    }
    return acc;
  }, 0);
};
const useContainerBreakpoint = (ref, breakpoints, initial = { x: 0, y: 0 }) => {
  const [breakpoint, setBreakPoint] = useState(initial);

  const elementObserver = useMemo(() => {
    return new ResizeObserver(() => {
      debounce(() => {
        if (!ref.current) return;
        const x = breakPointValue(breakpoints?.x, ref.current.clientWidth);
        const y = breakPointValue(breakpoints?.y, ref.current.clientHeight);
        setBreakPoint({ x: x, y: y });
      }, 200)();
    });
  }, [ref]);

  useEffect(() => {
    const element = ref?.current;
    if (element) {
      elementObserver.observe(element);
    }

    return () => {
      elementObserver.unobserve(element);
    };
  }, [ref, elementObserver]);
  return breakpoint;
};

export default useContainerBreakpoint;
